import { getUrl } from '@muse-web/url'

import { definedParams } from '@core/routes'

import { ALL_TYPES } from '../constants/searchFilters'

export type TGetSearchUrlParams = {
    query?: string
    type?: string
    sort?: string
    // Category name — the `/search/category/<name>` path segment, not the numeric id.
    category?: string
    page?: number
}

// The aggregate type and page 1 are dropped before `getUrl` sees them, so the base URL stays clean.
export const getSearchUrl = ({ query, type, sort, category, page }: TGetSearchUrlParams): string =>
    getUrl({
        url: category ? `/search/category/${category}` : '/search',
        params: definedParams({
            search_text: query || undefined,
            type: type && type !== ALL_TYPES ? type : undefined,
            sort: sort || undefined,
            page: page && page > 1 ? page : undefined,
        }),
    })
